import { render, staticRenderFns } from "./VTextFieldWithSuggestion.vue?vue&type=template&id=ea383dee&scoped=true"
import script from "./VTextFieldWithSuggestion.vue?vue&type=script&lang=js"
export * from "./VTextFieldWithSuggestion.vue?vue&type=script&lang=js"
import style0 from "./VTextFieldWithSuggestion.vue?vue&type=style&index=0&id=ea383dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea383dee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle,VSubheader,VTextField})
